export default __webpack_public_path__ + "static/media/admin.64ff05e8.png";